import { getQueryParameter } from "../util/helpers";
import { get } from "./fetch";

export const getData = async (crono: string, subcrono: string) => {
  //Stored Procedure: DashboardSituacion_Get_Proyectos OP:4
  var result = await get(
    `/api/informacion-proyectos/iniciativa/${crono}/${subcrono}`
  );
  return result;
};

export const getInfoProyectos = async (code?: string, queryParams?:{
  contraparte?:number,
  clave?:number,
  text?:string
}) => {
  let queryString = getQueryParameter(queryParams);
  //Stored Procedure: DashboardSituacion_Get_Proyectos OP:2
  var result = await get(`/api/informacion-proyectos${code ? "/"+code : ""}${queryString}`);
  return result;
};

export const getInfoProyectosPrograma = async (code: string) => {
  //Stored Procedure: DashboardSituacion_Get_Info_Programas OP:2
  var result = await get(`/api/informacion-proyectos/programa/${code}`);
  return result;
};

export const getInfoProyectosRegionales = async () => {
  //Stored Procedure: DashboardSituacion_Get_Info_Programas OP:2
  var result = await get(`/api/informacion-proyectos/regionales`);
  return result;
};

export const getInfoProyectosRegionalesFiltrada = async (queryParams?:{
  clave?:number,
  text?:string
}) => {
  let queryString = getQueryParameter(queryParams);
  //Stored Procedure: DashboardSituacion_Get_Info_Programas OP:2
  var result = await get(`/api/informacion-proyectos/regionales${queryString}`);
  return result;
};